interface TickWithWavyCircleProps {
  width?: string;
  height?: string;
  fillColor?: string;
}
const TickWithWavyCircle = (props: TickWithWavyCircleProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M23.4168 10.5857L21.78 8.94915C21.3915 8.56067 21.0732 7.79296 21.0732 7.2424V4.9279C21.0732 3.82691 20.1737 2.92747 19.073 2.92689H16.7576C16.2077 2.92689 15.4391 2.60796 15.0506 2.21976L13.414 0.58321C12.6364 -0.194403 11.3632 -0.194403 10.5856 0.58321L8.94901 2.22094C8.56017 2.60942 7.7907 2.92747 7.24196 2.92747H4.92746C3.82793 2.92747 2.92733 3.82691 2.92733 4.9279V7.24246C2.92733 7.79085 2.60904 8.56096 2.2205 8.94921L0.583649 10.5858C-0.19455 11.3634 -0.19455 12.6366 0.583649 13.4154L2.2205 15.052C2.60927 15.4405 2.92733 16.2103 2.92733 16.7587V19.0733C2.92733 20.1731 3.82793 21.0737 4.92746 21.0737H7.24202C7.79193 21.0737 8.56052 21.392 8.94907 21.7803L10.5856 23.4174C11.3632 24.1944 12.6364 24.1944 13.4141 23.4174L15.0506 21.7803C15.4394 21.3918 16.2077 21.0737 16.7577 21.0737H19.0731C20.1738 21.0737 21.0732 20.1731 21.0732 19.0733V16.7587C21.0732 16.2079 21.3918 15.4402 21.7801 15.052L23.4169 13.4154C24.1939 12.6366 24.1939 11.3633 23.4168 10.5857ZM10.4122 16.5003L5.9994 12.087L7.41365 10.673L10.4125 13.6719L16.5857 7.50016L17.9996 8.91411L10.4122 16.5003Z"
        fill={props?.fillColor ?? "white"}
      />
    </svg>
  );
};

export default TickWithWavyCircle;
